import { Button } from '@/components';
import { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

interface IProps {
    close: () => void;
}

const Dialog: FC<IProps> = ({ close }): ReactElement => {
    const { t } = useTranslation();
    return (
        <>
            <Mask></Mask>
            <Content>
                <Title>{t('base.warning')}</Title>
                <Section>
                    {t('base.exist')}
                    <b>「{t('base.valid vote')}」</b>
                    {t('base.tip1')}
                </Section>
                <Footer>
                    <Submit
                        onClick={() => {
                            close();
                        }}
                    >
                        {t('base.I konw')}
                    </Submit>
                </Footer>
            </Content>
        </>
    );
};
export default Dialog;
const Mask = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    z-index: 99;
`;
const Content = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 90%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 0.16rem 0.12rem;
    border-radius: 0.08rem;
    z-index: 100;
    @media screen and (min-width: 450px) {
        width: 450px;
    }
`;
const Title = styled.h3`
    height: 0.22rem;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 0.16rem;
    line-height: 0.22rem;
    text-align: center;
    color: #21212f;
    margin-bottom: 0.24rem;
`;
const Section = styled.section`
    font-family: 'Alibaba PuHuiTi 2.0';
    font-style: normal;
    font-weight: 400;
    font-size: 0.14rem;
    line-height: 0.2rem;
    color: #21212f;
    margin-bottom: 0.24rem;
    text-align: center;
`;
const Footer = styled.footer`
    display: flex;
    height: 0.4rem;
`;

const Submit = styled(Button)`
    height: 100%;
    flex: 1;
    background: #fff;
    border-radius: 0.08rem;
    font-family: 'Alibaba PuHuiTi 2.0';
    font-style: normal;
    font-weight: 400;
    font-size: 0.14rem;
    line-height: 0.2rem;
    color: #21212f;
    border: 1px solid #21212f;
`;
